// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EQEO","location":"Header_location__2Btaa"};